import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'manage-user-review',
  standalone: true,
  imports: [CommonModule],
  template: `
    <button
      class="manage-user-button dp-secondary-btn "
      (click)="onCellClick(rowData)"
    >
      {{ label }}
    </button>
  `,
  styles: [
    `
      .manage-user-button {
        width: 78px;
        height: 34px;
      }
    `,
  ],
})
export class ManageUserReviewComponent {
  @Input() label: string = 'Manage';
  @Input() rowData: any;
  @Output() cellClick: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  onCellClick(rowData: any) {
    this.cellClick.emit(rowData);
  }
}